import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setPageName } from '../../../../redux'
import { getData } from '../../../../assets/scripts/GeneralFunctions'
import CarCode from '../cars/child/CarCode'
import ServiceDateSection from './child/ServiceDateSection'
import moment from 'moment-jalaali'
import { select_class, title_class } from '../../../../functions/stateList'
import Select from 'react-select'
import { Images } from '../../../../assets/scripts/Images'

function CarServiceWithDate({ isUser = false }) {
  let { car_code } = useParams()
  const dispatch = useDispatch()
  const [date, setDate] = useState('')
  const [dates, setDates] = useState([])
  const [visits, setVisits] = useState([])
  const [lastVisit, setLastVisit] = useState(null)
  useEffect(() => {
    async function fetchData() {
      dispatch(setPageName('cars'))
      let api_result = await getData(
        isUser ? `customer/cars/${car_code}` : `admin/cars/${car_code}`,
        'get',
        {},
        true,
        false,
        isUser ? localStorage.getItem('userToken') : null
      )
      if (api_result) {
        if (api_result?.status === 200) {
          let result_data = api_result?.data
          let all_date = result_data?.['visit_dates']
          let all_visits = result_data?.car?.['visits']

          setDate({
            value: all_date[all_date?.length - 1],
            label: moment(all_date[all_date?.length - 1]?.split('T')[0]).format('jYYYY/jMM/jDD'),
          })
          setVisits(all_visits)
          let arr = []
          for (let item of all_date) {
            arr.push({ value: item, label: moment(item?.split('T')[0]).format('jYYYY/jMM/jDD') })
          }
          setDates(arr)
          setLastVisit(
            all_visits.find((visit) => visit.created_at === all_date[all_date?.length - 1])
          )
        }
      }
    }

    fetchData()
  }, [])

  const dateHandler = (e) => {
    setDate(e)
    setLastVisit(visits.find((visit) => visit.created_at === e.value))
  }
  return (
    <div className={isUser ? 'mx-6 md:mx-auto md:py-8 md:max-w-[1480px]' : ''}>
      {isUser && (
        <div className="flex item-center justify-center">
          <img
            src={Images.logo}
            className={'w-fit h-fit block dark:hidden'}
            alt="milani auto clinic"
          />
          <img
            src={Images.lightLogo}
            className={'w-fit h-fit hidden dark:block'}
            alt="milani auto clinic"
          />
        </div>
      )}
      <CarCode isUser={isUser} code={car_code} title={'تاریخچه خدمات خودروی'} />
      <div className="flex flex-col sm:flex-row sm:items-center mb-16">
        <div className="flex items-center justify-start">
          <i className={'icon-document-filter pl-2 text-xl dark:text-slate-300'} />
          <h3 className={'text-black text-lg dark:text-slate-300'}>تاریخ مراجعه را انتخاب کنید</h3>
        </div>
        <Select
          className={`${select_class} dv-dark-input w-full sm:w-40 sm:mr-3`}
          classNamePrefix="select"
          value={date}
          isRtl
          isSearchable
          name={'label'}
          options={dates}
          onChange={dateHandler}
        />
      </div>

      <div className="flex items-center justify-between mb-6">
        <h2 className={title_class}>آخرین خدمات اجرا شده</h2>
        <span className={'text-blue text-lg font-medium'}>{date?.label}</span>
      </div>

      <ServiceDateSection isUser={isUser} lastVisit={lastVisit} />
    </div>
  )
}

export default React.memo(CarServiceWithDate)
